// extracted by mini-css-extract-plugin
export default {"content":"kX+d8JUC6SUcrNAAB-zemA==","icon":"gc3o8y1u17UF+3-rWjfp1w==","backBtnWrapper":"RT1LPr5Wu2YcBOs36mUYbg==","backButtonIcon":"nh98PaahkPxA2yocssU3eQ=="};